import { useState, forwardRef, useImperativeHandle, useContext, useMemo } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import Iconfont from '@utils/Iconfont';
import { Input } from 'antd';
import { AppContext } from '@utils/AppContext';
import { SELECT_ORG_TYPE } from '@utils/CONST';
import eventBus from '@utils/eventBus';
import API from '@api/api.js';



const CreateTeamModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open: () => setOpen(true),
        close: () => setOpen(false),
    }));
    const { globalOrgInfo, setPayOrderInfo, payOrderInfo} = useContext(AppContext);
    const { selsectOrgType } = props;

    const [open, setOpen] = useState(false);
    const [searchText, setSearchText] = useState('');

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const list = useMemo(() => {
        return globalOrgInfo?.orgList?.filter(item => {
            if (searchText) {
                return item.orgName && item.orgName.toLowerCase().includes(searchText.toLowerCase());
            }
            return true;
        });
    }, [globalOrgInfo, searchText]);

    const postChangeOrg = (id) => {
        API.postChangeOrg({
            orgId: id
        }).then((res) => {
            if (res.code == 0) {
                window.location.reload();
            }
        })
    }

    const handleClick = (id) => {
        if (selsectOrgType == SELECT_ORG_TYPE.CHANGEORG) {
            postChangeOrg(id)
        } else {
            setPayOrderInfo({
                ...payOrderInfo,
                orgId: id,
            })
            eventBus.emit('pc_pay')
            setOpen(false)
        }
    }


    const selectTeamWarp = (
        <>
            <Input
                placeholder="请输入团队名称"
                size="large"
                value={searchText}
                onChange={handleSearchChange}
                className={styles.searchInput}
                prefix={<Iconfont className={styles.Icon} type="icon-SearchOutlined" />} />
            <div className={`${styles.selectTeamWarp} _beauty_scrollbar`}>
                {
                    list?.filter(item => {
                        // 非切换团队过滤掉个人版选项（即选择给团队充值得时候）
                        if (item.orgName === '个人版' && selsectOrgType != SELECT_ORG_TYPE.CHANGEORG) {
                            return false;
                        }
                        return true;
                    }).map((item, index) => (
                        <div
                            className={styles.selectTeamItem}
                            onClick={() => handleClick(item.id)}
                            key={index}>
                            <span>{item.orgName?.slice(0, 1)}</span>
                            <p>
                                <p>{item.orgName == '个人版' ? '个人版' : '团队版'}</p>
                                <p>{item.orgName}</p>
                            </p>
                            {
                                !item.status ? <span>未激活</span> : <span style={{ background: 'none' }}></span>
                            }
                        </div>
                    ))
                }
            </div>
        </>
    )

    return <>
        <PSAIModal
            title='选择团队'
            open={open}
            maskClosable={false}
            maxWidth={630}
            onCancel={() => setOpen(false)}
            getContainer={"body"}
            okText="创建团队"
            onOk={() => {
                eventBus.emit('OPEN_CREATE_TEAM')
                setOpen(false)
            }}
            cancelButtonProps={{ style: { display: 'none' } }}
            zIndex={1001}
        >
            {selectTeamWarp}
        </PSAIModal>
    </>
})
export default CreateTeamModal
